import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p className="footer__text">
        {new Date().getFullYear()} - Xadrez Brasil Negócios Digitais Ltda - Todos os direitos reservados.
      </p>
    </footer>
  );
}

export default Footer;
